import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { invalidateLibraryManagedProductGroupProducts } from './useLibraryManagedProductGroupProducts';
import { showNotification } from '../../shared/notification/toastNotification';
import { globalError } from '../../shared/notification/actions';
import { addProductsToGroupByIsbns } from './addProductsToGroupByIsbns';
import { invalidateLibraryManagedProductGroupFeaturedPages } from '../../yourborrowbox/marketing/productgroups/api/useLibraryManagedProductGroupsFeaturePages';

export const useAddProductsToGroupByIsbns = (productGroupId: string, onSuccess: () => void) => {
    const { t } = useTranslation();

    return useMutation((isbns: string) => addProductsToGroupByIsbns(productGroupId, { isbns }), {
        onSuccess: () => {
            onSuccess();
            invalidateLibraryManagedProductGroupProducts(productGroupId).then();
            invalidateLibraryManagedProductGroupFeaturedPages().then();
            showNotification(t('notifications.addByIsbnsBulkToGroup.success'));
        },
        onError: (error: any) => {
            globalError(error);
        }
    });
};
